import axios from '@/axios/api.request'

export const users = (from) => axios.request({
    url: '/finance/commission/check/users',
    data: from,
    method: 'post'
  })

  export const save = (from) => axios.request({
    url: '/finance/commission/check/save',
    data: from,
    method: 'post'
  })